export var AutoPreview = (window.AutoPreview = new Class({
   Implements: Options,

   options: {
      period: 3000,
      hideAtFirst: true,
   },

   initialize: function(formid, previewContainerid, previewCallback, options, previewAreaOptions) {
      if (options != null) {
         this.setOptions(options);
      }

      this.form = $(formid);
      this.previewContainer = $(previewContainerid);
      this.previewCallback = previewCallback;
      this.blankInfo = {};
      this.oldInfo = {};
      // Deal with options at some point.

      var h2 = new Element('h2', {
         class: 'muted',
         html: _js('Preview'),
      });

      this.previewArea = new Element('div', previewAreaOptions);

      if (this.options.hideAtFirst) {
         this.previewContainer.addClass('hidden');
      } else {
         this.previewContainer.removeClass('hidden');
         this.update();
      }

      this.previewContainer.adopt(h2);
      this.previewContainer.adopt(this.previewArea);

      this.blankInfo = this.oldInfo = FormLibrary.getValues(this.form);
      this.interval = setInterval(this.checkForQuestionChanges.bind(this), this.options.period);
   },

   checkForQuestionChanges: function(event, callback) {
      var info = FormLibrary.getValues(this.form);
      if (!this.areEqual(info, this.oldInfo) || !this.areEqual(this.oldInfo, info)) {
         const promise = this.update();
         if (callback) {
            promise.then(callback);
         }
         window.iFixit_hasChanged = true;
      }
      this.oldInfo = info;
   },

   update: function(event) {
      if (typeof event == 'object') {
         event.stop();
      }
      var info = FormLibrary.getValues(this.form);
      var previewArea = this.previewArea;
      return new Request.AjaxIO(this.previewCallback, {
         onSuccess: function(response) {
            previewArea.set('html', response);
            previewArea.getElements('.post-metadata a, .post-details a').each(function(link) {
               link.erase('href');
               // Make all non-user-entered links in the preview go nowhere.
            });
            previewArea.getElements('a').each(function(link) {
               link.set('target', '_BLANK');
               // Open all user-entered links in a new window.
            });
            if (response != null && response != '') {
               this.previewContainer.removeClass('hidden');
            } else if (this.options.hideAtFirst) {
               this.previewContainer.addClass('hidden');
            }
         }.bind(this),
      }).send(info);
   },

   areEqual: function(a, b) {
      for (var property in a) {
         if (typeof a[property] == 'object') {
            if (!b[property] || !this.areEqual(a[property], b[property])) {
               return false;
            }
         } else if (a[property] !== b[property]) {
            return false;
         }
      }
      return true;
   },
}));
